export interface Bonus {
  label: string
  title: string
  subtitle: string
  body: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'GUIDE DE POSE DES ÉLECTRODES ET DES 12 DÉRIVATIONS™',
    subtitle: 'Un tracé fiable dès le premier enregistrement',
    body: 'Préparation du patient, électrodes des membres et précordiales pas à pas, dérivations complémentaires, contrôle qualité du tracé et repérage d’une inversion d’électrodes avant de transmettre.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'ATLAS DES RYTHMES CARDIAQUES EN UN COUP D’ŒIL™',
    subtitle: 'Reconnaître un rythme en quelques secondes',
    body: 'Une page par rythme, une grille de tri (fréquence, régularité, largeur des QRS) et les rythmes qui se ressemblent placés côte à côte, avec un code couleur : surveiller, transmettre ou alerter.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'FICHES MÉMO ECG DE POCHE POUR LES GARDES ET LES STAGES™',
    subtitle: 'L’essentiel sur des cartes à garder sur soi',
    body: 'Repères du papier millimétré, valeurs normales de manuel, séquence de lecture, situations à reconnaître, quand alerter et phrases de transmission au format SAED.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'ECG ET MÉDICAMENTS : QT, ANTIARYTHMIQUES ET SURVEILLANCE INFIRMIÈRE™',
    subtitle: 'L’empreinte des traitements sur le tracé',
    body: 'QT en pratique, grandes familles de médicaments à effet sur l’ECG, électrolytes et surveillance autour de l’administration, toujours selon la prescription médicale et les protocoles de l’établissement.',
  },
  {
    label: '🎁 BONUS 5',
    title: 'CAHIER D’ENTRAÎNEMENT : 100 TRACÉS ECG À INTERPRÉTER™',
    subtitle: 'S’exercer tracé par tracé',
    body: '100 tracés pédagogiques en 5 niveaux, une grille de lecture identique pour chaque tracé et un corrigé détaillé, jusqu’à ce que la méthode devienne automatique.',
  },
]
